import atoms from "../../../../atoms";
import { ProductFilterMobileUIProps } from "../../interface";

const { Select, Input } = atoms;

export const ProductFilterMobileUI: React.FC<ProductFilterMobileUIProps> = ({
    brandList,
    filterData,
    handleChange,
    isContactLensProduct,
    productTypeList,
}) => {
    return (
        <div>
            <div className="mb-3">
                <Select
                    label="Brand"
                    options={brandList}
                    className={"w-100 product_multi_select"}
                    placeholder={"Select Brand"}
                    value={filterData?.brand_id}
                    isMulti={true}
                    onChange={(e: any) => {
                        handleChange("brand_id", e);
                    }}
                />
            </div>
            {!isContactLensProduct && (
                <div className="mb-3">
                    <Select
                        label="Product Type"
                        options={productTypeList}
                        className={"w-100 product_multi_select"}
                        placeholder={"Select Type"}
                        value={filterData.product_type_id}
                        isMulti={true}
                        isDisabled={isContactLensProduct}
                        onChange={(e: any) => {
                            handleChange("product_type_id", e);
                        }}
                    />
                </div>
            )}
            {!isContactLensProduct && (
                <div>
                    <Input
                        label="Model Number"
                        type={"text"}
                        className="input-height mb-3"
                        value={filterData.modal_number}
                        placeholder={"Enter Model Number"}
                        disabled={isContactLensProduct}
                        onChange={(e: any) => {
                            handleChange("modal_number", e.target.value);
                        }}
                    />
                </div>
            )}
        </div>
    );
};
